// extracted by mini-css-extract-plugin
export default {"container":"_180iI","title":"Pol8_"};